export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#96dcb8ee-54ba-4afd-ba88-a745dcd58865",
        children: [
          {
            type: "tabset",
            id: "#1261f01b-ac4d-4b08-a817-b025d6d5c313",
            weight: 7.142857142857143,
            enableMaximize: false,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62daxxx41b5881cc",
                name: "",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
            active: true,
          },
          {
            type: "row",
            id: "#d89e0622-b83a-4395-96df-8cd484936a06",
            weight: 92.85714285714286,
            children: [
              {
                type: "row",
                id: "#4d90f834-b72e-439c-b6bf-c4134767aeac",
                weight: 12.043449271980291,
                children: [
                  {
                    type: "tabset",
                    id: "#60a1abce-2727-4231-bc97-8c1430e906ae",
                    weight: 64,
                    enableMaximize: false,
                    tabStripHeight: 6,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62axxx41b5881cc",
                        name: "",
                        component: "OaRChart",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#7d34fca7-c3d6-4b39-85c9-5aa346ecf8cd",
                    weight: 64,
                    enableMaximize: false,
                    tabStripHeight: 6,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62adyyy41b5881cc",
                        name: "",
                        component: "VaRChart",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
              {
                type: "row",
                id: "#ea0ece4d-0195-4da4-9bbd-66b70f7da327",
                weight: 1.6246680920911594,
                children: [
                  {
                    type: "tabset",
                    id: "#e6f0fd1d-fca3-49a5-8e85-b5669d572333",
                    weight: 8.035683688909375,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852addd-62xad41b5881ccx",
                        component: "ModelDate",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#af9318e1-12a2-4775-9bff-8c16e81e1a83",
                    weight: 6.516041501321928,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-exc93-4600-852addd-62ad41b5881ccx",
                        name: "",
                        component: "Legend",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
              {
                type: "row",
                id: "#c31b20f1-cbe1-467f-a96b-2552338f9b97",
                weight: 1.2536019229098452,
                children: [
                  {
                    type: "tabset",
                    id: "#f0dc8076-44e2-4068-8114-97e99967e4e3",
                    weight: 4.226742524826158,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62ad41b5881ccx",
                        name: "",
                        component: "RiskModel",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#b382b7a6-3299-4262-a78c-62f4e4822aa1",
                    weight: 4.159068892627884,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852addd-62ad4dd1b5881ccx",
                        component: " Pctile ",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#37ea077e-0d0b-40d5-a26e-2b846033ffa6",
                    weight: 8.377267843176183,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852axddd-62ad41b5e881ccx",
                        component: "Horizon",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#faa5c175-2bde-417f-b165-fad618624339",
                    weight: 3.8124093178526346,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-exc93-460x0-852addd-62ad41b5881ccx",
                        name: "",
                        component: "RiskModelLegend",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#fd18d01c-5117-4edd-b932-8f2507a357b4",
                    weight: 9.918102423996286,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852axddd-62ad41b5881ccx",
                        component: "Ticker",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
